export const VILLA_MAP_PLACE_QUERY_AUTOCOMPLETE_ENDPOINT =
  // "https://g0o52xt6nc.execute-api.ap-southeast-1.amazonaws.com/dev/googlemap-api/web/place/autocomplete"; // dev
  "https://shop.villamarket.com/api/googlemapapi/web/place/autocomplete"; // production

export const VILLA_MAP_DIRECTION_ENDPOINT =
  // "https://g0o52xt6nc.execute-api.ap-southeast-1.amazonaws.com/dev/googlemap-api/web/direction"; // dev
  "https://shop.villamarket.com/api/googlemapapi/web/direction"; // production 

export const VILLA_MAP_GEOCODE_ENDPOINT =
  // "https://g0o52xt6nc.execute-api.ap-southeast-1.amazonaws.com/dev/googlemap-api/web/geocode"; // dev
  "https://shop.villamarket.com/api/googlemapapi/web/geocode"; // production 

export const VILLA_MAP_PLACE_DETAIL_ENDPOINT =
  // "https://g0o52xt6nc.execute-api.ap-southeast-1.amazonaws.com/dev/googlemap-api/app/place-details"; // dev
  "https://shop.villamarket.com/api/googlemapapi/app/place-details"; // production
